import AccountInformationForm from '@/components/user/settings/account/account-information-form';
import { useAuth } from '@/contexts/auth-context';
import AccountSettingsPageShell from './AccountSettingsPageShell';

const AccountProfileSettingsPage = () => {
  const { user } = useAuth();

  return (
    <AccountSettingsPageShell
      titleKey="settings.accountNav.profile"
      sectionTitleKey="settings.accountPages.profile.personalInformation"
      sectionDescriptionKey="settings.accountPages.profile.description"
    >
      <AccountInformationForm
        defaultValues={{
          firstName: user?.firstName || '',
          lastName: user?.lastName || '',
        }}
        showActions
      />
    </AccountSettingsPageShell>
  );
};

export default AccountProfileSettingsPage;
